import React from "react";
import Button from "./Button";
import LegalDocument from "./LegalDocument";
import { privacyDocument, termsDocument } from "../content/legalContent";
import "./ConsentBanner.css";

const CONSENT_STORAGE_KEY = "asasiasaPrivacyConsentAccepted";

const ConsentBanner = () => {
  const [showConsentModal, setShowConsentModal] = React.useState(false);
  const [showAcceptedNotice, setShowAcceptedNotice] = React.useState(false);
  const [activeDocument, setActiveDocument] = React.useState("privacy");

  React.useEffect(() => {
    const consentAccepted =
      window.localStorage.getItem(CONSENT_STORAGE_KEY) === "true";

    setShowConsentModal(!consentAccepted);
  }, []);

  React.useEffect(() => {
    if (!showAcceptedNotice) {
      return undefined;
    }

    const dismissNotice = () => {
      setShowAcceptedNotice(false);
    };

    const registerClickDismiss = window.setTimeout(() => {
      window.addEventListener("pointerdown", dismissNotice);
    }, 0);

    const autoDismiss = window.setTimeout(() => {
      setShowAcceptedNotice(false);
    }, 5000);

    return () => {
      window.clearTimeout(registerClickDismiss);
      window.clearTimeout(autoDismiss);
      window.removeEventListener("pointerdown", dismissNotice);
    };
  }, [showAcceptedNotice]);

  const handleAccept = () => {
    window.localStorage.setItem(CONSENT_STORAGE_KEY, "true");
    setShowConsentModal(false);
    setShowAcceptedNotice(true);
  };

  const handleDeny = () => {
    window.localStorage.removeItem(CONSENT_STORAGE_KEY);
    window.location.assign("/");
  };

  const currentDocument =
    activeDocument === "terms" ? termsDocument : privacyDocument;

  return (
    <>
      {showConsentModal && (
        <div className="consent-banner-overlay">
          <div
            className="consent-banner-card"
            role="dialog"
            aria-modal="true"
            aria-labelledby="consent-banner-title"
          >
            <div className="consent-banner-header">
              <div className="consent-banner-topbar">
                <div className="consent-banner-topbar-copy">
                  <span className="consent-banner-eyebrow">Privacy Notice</span>
                  <h2 id="consent-banner-title" className="consent-banner-title">
                    Review Asasiasa&apos;s privacy notice and terms before continuing
                  </h2>
                </div>
                <div
                  className="consent-banner-tabs"
                  role="tablist"
                  aria-label="Legal documents"
                >
                  <button
                    type="button"
                    role="tab"
                    aria-selected={activeDocument === "privacy"}
                    className={`consent-banner-tab${
                      activeDocument === "privacy" ? " is-active" : ""
                    }`}
                    onClick={() => setActiveDocument("privacy")}
                  >
                    Privacy
                  </button>
                  <button
                    type="button"
                    role="tab"
                    aria-selected={activeDocument === "terms"}
                    className={`consent-banner-tab${
                      activeDocument === "terms" ? " is-active" : ""
                    }`}
                    onClick={() => setActiveDocument("terms")}
                  >
                    Terms
                  </button>
                </div>
              </div>
              <p className="consent-banner-copy">
                We use essential cookies and app storage to keep login, security,
                study progress, and interface preferences working properly.
              </p>
              <p className="consent-banner-copy consent-banner-copy-secondary">
                If you do not agree, choose <strong>Deny &amp; Leave Site</strong>.
              </p>
            </div>
            <div className="consent-banner-legal-scroll">
              <LegalDocument
                documentData={currentDocument}
                compact={true}
                showTitle={false}
                className="legal-document--stacked"
              />
            </div>
            <div className="consent-banner-actions">
              <Button
                type="button"
                className="button-middle button-middle-blue consent-banner-accept-button"
                onClick={handleAccept}
              >
                Accept
              </Button>
              <Button
                type="button"
                className="button-middle button-middle-red consent-banner-deny-button"
                onClick={handleDeny}
              >
                Deny &amp; Leave Site
              </Button>
            </div>
          </div>
        </div>
      )}

      {showAcceptedNotice && (
        <div className="consent-banner-accepted-pill" role="status">
          Privacy accepted
        </div>
      )}
    </>
  );
};

export default ConsentBanner;
